module.exports = __webpack_public_path__ + "static/img/hotelface.311c784.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandGfei/hotelface.png
// module id = 1128
// module chunks = 18